import React, { useState } from "react";
import { useGetQualityParameterQuery } from "features/Procurement/common/ProcurementApiSlice";
import QualityParamsModal from "features/Procurement/common/QualityParamsModal";
import { Modal, Table } from "react-bootstrap";

export const ProjectCommodities = ({ selectedCommodities }) => {
  const [selectedCommodity, setSelectedCommodity] = useState(null);

  const { data: QualityParameter, isFetching } = useGetQualityParameterQuery(
    selectedCommodity?.code,
    {
      skip: !selectedCommodity?.code,
    }
  );
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="">
      <div className="row p-0 p-lg-2">
        {Array.isArray(selectedCommodities) &&
        selectedCommodities.length > 0 ? (
          selectedCommodities.map((item, ind) => (
            <div key={ind} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
              <div
                className="commodity-card"
                onClick={() => {
                  setSelectedCommodity(item);
                  setShowModal(true);
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="commodity-image">
                  <img src={item.image_url} alt={item.name} />
                </div>
                <div className="commodity-info">
                  <h6 className="commodity-name">{item.name}</h6>
                  <span className="commodity-category">{item.category}</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center py-4">
            <p className="text-muted" style={{ fontSize: "1rem" }}>
              No commodities available
            </p>
          </div>
        )}
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            QUALITY PARAMETERS
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "2%" }}>
          <div className="d-flex row">
            <div className="col-lg-3">
              <h4 className="mt-2">
                {QualityParameter?.data[0]?.commodity_name}
              </h4>
              {console.log("selectedCommodity 9999", QualityParameter)}

              <div className="d-flex  align-items-center">
                <img
                  className="img-fluid rounded"
                  src={selectedCommodity?.image_url}
                />
              </div>
            </div>
            <div className="col-lg-9">
              <Table striped hover className="">
                <thead>
                  <tr className="">
                    <th className="fs-6 w-50">Parameter</th>
                    <th className="fs-6">Range One</th>
                    <th className="fs-6">Range Two</th>
                    <th className="fs-6">Range Three </th>
                  </tr>
                </thead>
                <tbody>
                  {QualityParameter?.data?.map((data, index) => {
                    return (
                      <tr key={index} className="mt-3">
                        <td>{data.fields}</td>
                        <td>{data.range_one}</td>
                        <td>{data.range_two}</td>
                        <td>
                          {data.range_three === "nan" ? "—" : data.range_three}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
